// Monta um "registro representativo" a partir de várias atividades do MESMO
// questionário — usado apenas pelo cabeçalho/rodapé do modal de execução em
// massa (título, contagem de selecionados, checklist) e por
// `useIsBulkExecution`/`useBulkServiceOrderIds`.
//
// A tela de execução em massa em si (a grade) NÃO usa mais este registro
// mesclado para exibir respostas: cada linha mostra a resposta real daquela
// atividade específica (ver `bulk/_data/rowReplies.js`), então não existe
// mais o conceito de "campo em branco por divergência" entre atividades.

export const mergeBulkServiceOrders = serviceOrders => {
  if (!serviceOrders || serviceOrders.length === 0) return null

  const [first] = serviceOrders

  return {
    ...first,
    id: null,
    yearlyId: null,
    name: null,
    documents: [],
    fieldValues: [],
    replies: [],
    bulk: {
      ids: serviceOrders.map(so => so.id),
      count: serviceOrders.length,
      statusName: first?.status?.name
    }
  }
}
